<template>
  <div>
    <!-- <Datatable /> -->
    <div
      v-if="members.length === 0"
      class="d-flex align-items-center justify-content-center"
    >
      <Spinner />
    </div>
    <div v-else>
      <table id="table" ref="dt"></table>
    </div>
  </div>
</template>

<script>
import Spinner from "@/components/Spinner";
import userList from "@/api/users/list";
import axios from "@/helpers/base";

export default {
  name: "BookAMember",
  components: {
    // Datatable,
    Spinner
  },
  data: function() {
    return {
      members: [],
      tableFields: []
    };
  },
  async mounted() {
    this.members = await userList();

    this.tableFields = [
      {
        name: "avatar",
        title: ""
      },
      {
        name: "lastName",
        title: "Last Name",
        sortfield: "lastName"
      },
      {
        name: "firstName",
        title: "First Name",
        sortfield: "firstName"
      },
      {
        name: "",
        title: "Actions"
      }
    ];
  },
  methods: {
    createTable() {
      const url = axios.defaults.baseURL;
      this.$refs.dt.DataTable({
        ajax: `${url}/users`,
        dataSrc: "data"
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
